import { Injectable } from '@angular/core';

/**
 * Centralised service to handle navigation to authentication endpoints.
 * Ensures only a single redirect to login/logout occurs (deduplicates concurrent callers).
 */
@Injectable({ providedIn: 'root' })
export class AuthRedirectService {
    private isRedirecting = false;

    /**
     * Redirect to the BFF login page with optional return URL. Deduplicates concurrent calls.
     */
    redirectToLogin(returnUrl?: string) {
        if (this.isRedirecting) {
            return;
        }
        this.isRedirecting = true;

        const url = `/bff/login${returnUrl ? '?returnUrl=' + encodeURIComponent(returnUrl) : ''}`;
        // Use top window to ensure whole app navigates
        try {
            window.top.location.href = url;
        } catch (e) {
            // Fallback if cross-origin prevents window.top access
            window.location.href = url;
        }
    }

    /**
     * Redirect to an explicit URL (logout or other). Deduplicated.
     */
    redirectToUrl(url: string) {
        if (this.isRedirecting) {
            return;
        }
        this.isRedirecting = true;
        try {
            window.top.location.href = url;
        } catch (e) {
            window.location.href = url;
        }
    }

    /**
     * Allow tests or special flows to reset the redirect guard.
     */
    resetGuard() {
        this.isRedirecting = false;
    }
}
